import React from 'react';

import type { ContactSubDetailsPropsType } from '~/components/Contacts/ContactMiniCard/types';
import Text from '~/components/core/TextComponents/Text';
import { BriefcaseIcon } from '~/components/icons';

const LABEL = 'Business Number';

const BusinessNumber: React.FC<ContactSubDetailsPropsType> = ({ contact }) => {
  return (
    <>
      <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.SEMI_BOLD}>
        {LABEL}
      </Text>
      {contact.au_nz_business_number ? (
        <div className="my-4 flex items-center">
          <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.REGULAR} className="grow">
            {contact.au_nz_business_number}
          </Text>
          <BriefcaseIcon iconColor="currentColor" />
        </div>
      ) : null}
    </>
  );
};

export default BusinessNumber;
